module.exports = __webpack_public_path__ + "img/base_station.ad7de05a.png";